import { render } from "./BaseContestDayCard.vue?vue&type=template&id=e15cec58&ts=true"
import script from "./BaseContestDayCard.vue?vue&type=script&lang=ts"
export * from "./BaseContestDayCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__